import type { SheetIds } from '@frameio/shared/contexts';
import { theme } from '@frameio/vapor';

/**
 * When any app sheet is open, the nav rail matches the sheet surface; use that
 * color for badge rings. Otherwise use the default rail background so the ring
 * is visually continuous with the nav.
 */
export function getAppSheetAwareBadgeBorderColor(currentSheetId: SheetIds) {
  return currentSheetId != null
    ? theme.colors.components.sheet.background
    : theme.colors.background.base;
}
